module.exports = __webpack_public_path__ + "img/face-id-square.d4091910.svg";